export const content = {
  bannerText:
    'Guardamos somente cookies essenciais para garantir sua experiência de uso. Ao utilizar nossos serviços, você concorda com o uso dos cookies.',
  buttonText: 'OK'
}
